import {gsap} from "../LibrariesImport";

export default class BlockGallerySlider {
	static init() {

		let blocks = document.querySelectorAll('.block-gallery-slider');

		blocks.forEach( (block) => {

			let swiper = block.querySelector('.block-gallery-swiper');
			const grab = block.querySelector('.grabbing');

			const prev = block.querySelector(".gallery-button-prev");
			const next = block.querySelector(".gallery-button-next");

			const swip = new Swiper(swiper, {
				slidesPerView: "auto",
				grabCursor: true,
				navigation: {
					prevEl: prev,
					nextEl: next,
				},
				on:{
					touchStart: () => {
						gsap.to(grab, 0.2, {
							scale: 0.2
						});
					},
					touchMove: (swiper, e) => {
						let sliderOffset = block.getBoundingClientRect();

						gsap.to(grab, 0.3, {
							top: e.clientY - sliderOffset.top,
							left: e.clientX - sliderOffset.left
						});
					},
					touchEnd: () => {
						gsap.to(grab, 0.2, {
							scale: 1
						});
					},
					lock: () => {
						block.classList.remove("swiper-is-active");
					},
					unlock: () => {
						block.classList.add("swiper-is-active");
					}
				}
			});

			swip.slides.forEach((slide) => {
				slide.querySelectorAll('.gallery-zoom').forEach( (link) => {
					link.addEventListener("mouseenter", () => {
						gsap.to(grab, 0.2, {
							scale: 0.2,
							opacity: 0
						});
					});
					link.addEventListener("mouseleave", () => {
						gsap.to(grab, 0.2, {
							scale: 1,
							opacity: 1
						});
					});
				});
			});

			swiper.addEventListener("mouseenter", (e) => {
				let sliderOffset = block.getBoundingClientRect();

				gsap.to(grab, 0.2, {
					scale: 1,
					opacity: 1
				});

				gsap.set(grab, {
					top: e.clientY - sliderOffset.top,
					left: e.clientX - sliderOffset.left,
				});
			});

			swiper.addEventListener("mousemove", (e) => {
				let sliderOffset = block.getBoundingClientRect();
				gsap.to(grab, 0.3, {
					top: e.clientY - sliderOffset.top,
					left: e.clientX - sliderOffset.left
				});
			});

			swiper.addEventListener("mouseleave", () => {
				gsap.to(grab, 0.2, {
					scale: 0,
					overwrite: true
				});
			});

		});


	}
}
